import React, { CSSProperties } from 'react';
import { Chip, ChipProps } from '@mui/material';

export type LabelProps = Omit<ChipProps, 'variant' | 'size'> & {
  /** Base hue for the label's text, tinted fill and outline. */
  borderColor?: CSSProperties['borderColor'];
};

/** Shared outlined label; visual defaults live in the global MuiChip theme. */
export const Label = React.forwardRef<HTMLDivElement, LabelProps>(
  ({ borderColor, sx, ...props }, ref) => (
    <Chip
      ref={ref}
      {...props}
      variant="outlined"
      size="small"
      sx={[
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        { '--label-border-color': borderColor, minWidth: 0, maxWidth: '100%' },
      ]}
    />
  ),
);
Label.displayName = 'Label';
